import React from "react";
import { Datagrid, TextField, DateField, Link } from "react-admin";
import { List } from "../../../components/customize-react-admin";
import Pagination from "../../../components/qa/Pagination";
import CategoryField from "../../../components/guide/CategoryField";

const IDLinkField = props => (
  <Link to={`/feedbacks/${props.record.id}/show`}>
    <TextField {...props} />
  </Link>
);

export const FeedbackList = props => {
  const perPage = 50;
  const defaultSort = {
    field: "modify_date",
    order: "DESC"
  };
  return (
    <List
      {...props}
      title="Feedback 列表"
      perPage={perPage}
      sort={defaultSort}
      pagination={<Pagination />}
    >
      <Datagrid>
        <IDLinkField source="message" label="內文" sortable={false} />
        <CategoryField label="category" sortable={false} />
        <DateField showTime source="create_date" label="建立時間" />
      </Datagrid>
    </List>
  );
};
